import { CarBody } from "../data/bruktbilsalgBackend/types/car.types";

export const translateCarBody = (carBody: CarBody) => {
  switch (carBody) {
    case "Box":
      return "Kassebil";
    case "CombiCoupe":
      return "Kombi-coupe";
    case "Convertible":
      return "Cabriolet";
    case "Coupe":
      return "Coupe";
    case "MultiPurpose":
      return "Flerbruksbil";
    case "Pickup":
      return "Pickup";
    case "Sedan":
      return "Sedan";
    case "SportsCar":
      return "Sportsbil";
    case "SportUtilityVehicle":
      return "SUV/Offroad";
    case "StationWagon":
      return "Stasjonsvogn";
    default:
      return "";
  }
};
